/**
 * Un account Google collegato non significa che il CRM possa vedere i calendari: nel modale di
 * collegamento il permesso Calendario si spunta a parte. Chi lo salta resta "collegato" con
 * l'elenco dei calendari vuoto e, fino al 18/09/2026, senza nessuna spiegazione: le attività
 * non finivano su Google e non lo diceva niente (Mattia Giardini, Viva la Farina).
 */

export const CALENDAR_SCOPE = 'https://www.googleapis.com/auth/calendar';
export const CALENDAR_READONLY_SCOPE = 'https://www.googleapis.com/auth/calendar.readonly';

export function haPermessoCalendario(scopes: unknown): boolean {
  if (!Array.isArray(scopes)) return false;
  return scopes.some((s) => s === CALENDAR_SCOPE || s === CALENDAR_READONLY_SCOPE);
}

/** True quando l'account e' collegato ma senza il permesso dei calendari: e' il caso da spiegare. */
export function mancaPermessoCalendario(connesso: boolean, scopes: unknown): boolean {
  return !!connesso && !haPermessoCalendario(scopes);
}
